module.exports = __webpack_public_path__ + "static/img/dn_logo_white.5d2810b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dn_logo_white.png
// module id = nTWv
// module chunks = 13